import React from "react"
import { useEffect } from "react"
import { initGA, logPageView } from "./analytics"
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom"
import NotFound from "./pages/general/NotFound"
import Landing from "./pages/general/Landing"
import Login from "./pages/userAuthentication/Login"
import SignUp from "./pages/userAuthentication/SignUp"
import Authentication from "./pages/userAuthentication/Authentication"
import Onboarding from "./pages/protected/Onboarding"
import HomeFeed from "./pages/protected/HomeFeed"
import Coach from "./pages/protected/Coach"
import Calendar from "./pages/protected/Calendar"
import Chat from "./pages/protected/Chat"
import Profile from "./pages/protected/Profile"
import ClubDashboard from "./pages/protected/ClubDashboard"
import Account from "./pages/protected/Account"
import Notifications from "./pages/protected/settings/Notifications"
import Faqs from "./pages/protected/settings/Faqs"
import Payments from './pages/protected/settings/Payments'
import ComingSoon from "./pages/general/ComingSoon"
import OrderSuccessful from "./pages/protected/orders/OrderSuccessful"
import OrderCancelled from "./pages/protected/orders/OrderCancelled"
import ConfirmEmail from "./pages/protected/misc/ConfirmEmail"
import Invite from "./pages/protected/settings/Invite"
import Privacy from "./pages/protected/settings/Privacy"
import DeleteAccount from "./pages/protected/settings/DeleteAccount"
import Contact from "./pages/protected/settings/Contact"
import AboutUs from "./pages/general/AboutUs"
import TermsConditions from "./pages/general/TermsConditions"
import PrivacyPolicy from "./pages/general/PrivacyPolicy"
import HowSkilljaWorks from "./pages/general/HowSkilljaWorks"
import OrderReview from "./pages/protected/orders/OrderReview"
import Merchandise from "./pages/general/merchandise/Merchandise"
import MerchandisePreview from "./pages/general/merchandise/MerchandisePreview"
import MerchandiseOrderSuccessful from "./pages/general/merchandise/MerchandiseOrderSuccessful"
import MerchandiseOrderCancelled from "./pages/general/merchandise/MerchandiseOrderCancelled"
import ConfirmStripeOnboarding from "./pages/protected/misc/ConfirmStripeOnboarding"
import RefreshStripeOnboarding from "./pages/protected/misc/RefreshStripeOnboarding"
import Admin from "./pages/protected/Admin"
import CoachScreening from "./pages/protected/misc/CoachScreening"
import NewsletterUnsubscribe from "./pages/protected/misc/NewsletterUnsubscribe"
import { GoogleOAuthProvider } from '@react-oauth/google'
import FinancialReport from "./pages/protected/club/FinancialReport"
import ClubInvite from "./pages/protected/club/ClubInvite"
import ForgotPassword from "./pages/general/ForgotPassword"
import UpdatePassword from "./pages/general/UpdatePassword"


export default function App() {
  const RouteChangeTracker = () => {
    const location = useLocation()
  
    useEffect(() => {
      if (window.gtag) {
        logPageView()
      }
    }, [location])
  
    return null
  }

  useEffect(() => {
    initGA();
  }, []);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <BrowserRouter>
      <RouteChangeTracker />
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Landing />} />
        <Route path="coming-soon" element={<ComingSoon />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<SignUp />} />
        <Route path="home-feed" element={<HomeFeed />} />
        <Route path="faqs" element={<Faqs />} />
        <Route path="contact-us" element={<Contact />} />
        <Route path="about-us" element={<AboutUs />} />
        <Route path="terms-conditions" element={<TermsConditions />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="order-success" element={<OrderSuccessful />} />
        <Route path="order-cancelled" element={<OrderCancelled />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="update-password" element={<UpdatePassword />} />
        <Route path="admin-home" element={<Admin />} />
        <Route path="merchandise-order-success" element={<MerchandiseOrderSuccessful />} />
        <Route path="merchandise-order-cancelled" element={<MerchandiseOrderCancelled />} />
        <Route path="order-review" element={<OrderReview />} />
        <Route path="confirm-account" element={<ConfirmEmail />} />
        <Route path="club-invite" element={<ClubInvite />} />
        <Route path="coach-screening" element={<CoachScreening />} />
        <Route path="stripe-onboarding-success" element={<ConfirmStripeOnboarding />} />
        <Route path="stripe-onboarding-refresh" element={<RefreshStripeOnboarding />} />
        <Route path="how-skillja-works" element={<HowSkilljaWorks />} />
        <Route path="unsubscribe" element={<NewsletterUnsubscribe />} />
        <Route path="merchandise">
          <Route index element={<Merchandise />} />
          <Route path=":productId" element={<MerchandisePreview/>} />  
        </Route>
        <Route path="auth" element={<Authentication />}>
          <Route path="onboarding" element={<Onboarding />} />
          <Route path="coach" element={<Coach />} />
          <Route path="calendar" element={<Calendar />} />
          <Route path="chat" element={<Chat />} />
          <Route path="profile" element={<Profile />} />
          <Route path="club-dashboard">
            <Route index element={<ClubDashboard />} />
            <Route path="financial-report" element={<FinancialReport />} />
          </Route>
          <Route path="settings">
            <Route index element={<Account />} />
            <Route path="payments" element={<Payments />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="invite" element={<Invite />} />
            <Route path="privacy">
              <Route index element={<Privacy/>} />
              <Route path="delete-account" element={<DeleteAccount/>} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
    </GoogleOAuthProvider>
  )
}

 